import { render, staticRenderFns } from "./MainWordCloud.vue?vue&type=template&id=22953e27&scoped=true"
import script from "./MainWordCloud.vue?vue&type=script&lang=js"
export * from "./MainWordCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22953e27",
  null
  
)

export default component.exports